export default {
  code: 'ja',
  messages: {
    email: 'メールアドレスが正しく入力されているかご確認ください。',
    required: '{_field_}を入力してください。',
    confirmed: '{_field_}が一致しません。',
    min(name, event) {
      return `${name}を${event.length}文字以上入力してください。`
    },
  },
}
